import React, { Component } from 'react';
import HttpService from '../../util/HttpService';
import { If } from '../../components/ConditionalRendering';
import {
    isDefined,
    decimalFormat,
    parseDecimal,
    estadoOptions,
    tipoFreteOptions,
    b64toBlob,
    mascaraCep,
    isEmpty
} from '../../util/Common';
import * as LocalStorageManager from '../../util/StorageManager';
import _ from 'lodash';
import Moment from 'moment';
import download from "downloadjs";
import { toast } from 'react-toastify';
import ModalProdutos from './ModalProdutos';
import ButtonLink from '../../components/ButtonLink';
import ConfirmSave from '../../components/ConfirmSave';
import EditableLabel from '../../components/EditableLabel';
import { Input, Dropdown, Message, Icon, Divider, Table, TextArea, Button, Label, Form, Dimmer, Loader, Modal } from 'semantic-ui-react';

class DetalheOrcamento extends Component {

    constructor(props){
        super(props);
        this.state = {
            orcamento: {},
            senhaConfirmacao: '',
            confirmarSalvar: false,
            confirmarFecharPedido: false,
            isEditing: false,
            isPrinting: false,
            isLoading: false,
            isLoadingCep: false
        }
    }

    componentDidMount(){
        /* Busca o parametro :idtOrcamento na URL, declarado no Router */
        if(isDefined(this.props.match) && isDefined(this.props.history)){
            this.buscarDetalhesOrcamento(this.props.match.params.idtOrcamento);
        }
    }
    
    buscarFormasPagamento = (idtCliente) => {
        HttpService.call(
            'sistema/combos',
            'formasPagamento',
            [
                idtCliente
            ],
            (formasPagamento) => this.setState({ formasPagamento })
        );
    }

    buscarCidades = (uf) => {
        this.setState({ cidades: undefined });

        HttpService.call(
            'sistema/combos',
            'cidades',
            [
                uf
            ],
            (cidades) => this.setState({ cidades })
        );
    }

    buscarDetalhesOrcamento = (idtPedido) => {
        this.setState({ isLoading: true });
        idtPedido = parseInt(idtPedido, 10);
        const urlOrcamentos = this.props.match.url.replace('/' + idtPedido, '');

        if(isNaN(idtPedido)){
            this.props.history.push(urlOrcamentos);
        }else{
            HttpService.call(
                'cadastro/orcamentoVenda',
                'buscarDetalhesPedido',
                [
                    idtPedido,
                    LocalStorageManager.getOrigem().idt,
                    'S', // isOrcamento = 'S', sao os pedidos em aberto (orcamentos).
                ],
                (orcamento) => {
                    if(isDefined(orcamento)){
                        orcamento.dataEntrega = isDefined(orcamento.dataEntrega) ? new Moment(orcamento.dataEntrega, 'YYYYMMDD') : null;
                        orcamento.dataPedido = new Moment(orcamento.dataPedido, 'YYYYMMDD');

                        if(orcamento.formaPagamentoId !== ''){
                            orcamento.formaPagamentoId = parseInt(orcamento.formaPagamentoId, 10);
                        }

                        this.buscarCidades(orcamento.estado);
                        this.buscarFormasPagamento(orcamento.clienteId);
                        this.setState({ orcamento, isLoading: false, isEditing: false });
                    }else{
                        this.props.history.push(urlOrcamentos);
                    }
                }
            )
        }
    }
    
	salvarOrcamento = (finishLoading) => {
		const { orcamento, confirmarSalvar, senhaConfirmacao } = this.state;

		// Testa se foi selecionada uma forma de pagamento e que ainda nao foi confirmada
		if(orcamento.formaPagamentoId !== '' && !confirmarSalvar){
			this.setState({ confirmarSalvar: true, senhaConfirmacao: '' });
		}else{
            this.setState({ isLoading: true });

			HttpService.call(
				'cadastro/orcamentoVenda',
				'salvarOrcamento',
				[
					{
                        ...orcamento,
                        formaPagamentoId: orcamento.formaPagamentoId !== '' ? orcamento.formaPagamentoId : null,
						dataPedido: orcamento.dataPedido.format('YYYYMMDD'),
						dataEntrega: orcamento.dataEntrega.format('YYYYMMDD')
					},
					{
						autenticar: orcamento.formaPagamentoId !== '',
						tipoLogin: LocalStorageManager.getLoggedUser().isCliente ? 'cliente' : 'representante',
						documento: LocalStorageManager.getLoggedUser().documento,
						senha: senhaConfirmacao
					}
				],
				(retorno) => {
					if(isDefined(retorno)){
						if(retorno.result){
							this.setState({ isEditing: false, confirmarSalvar: false });
							toast.success('Orçamento salvo com sucesso!');
						}else if(isDefined(retorno.mensagem)){
							toast.error('Senha de confirmação incorreta!');
						}
					}else{
						toast.error('Erro ao salvar orçamento.');
					}
                    
                    this.setState({ senhaConfirmacao: '', isLoading: false });

                    if(isDefined(finishLoading)){
                        // Executa funcao que pode vir por parametro, nesse caso serve
                        // para quando a funcao de salvar eh chamada na tela de
                        // confirmacao, eh passado uma funcao para parar o 'loading'
                        // do botao de salvar.
                        finishLoading();
                    }
				}
			);
		}
    }
    
    fecharPedido = (finishLoading) => {
        const { orcamento, confirmarFecharPedido } = this.state;

		if(!confirmarFecharPedido){
            this.setState({ confirmarFecharPedido: true });
		}else{
            HttpService.call(
                'cadastro/orcamentoVenda',
                'fecharPedido',
                [
                    orcamento.idtPedido
                ],
                (retorno) => {
                    if(isDefined(retorno) && retorno.result){
                        this.setState({ confirmarFecharPedido: false });
                        toast.success('Pedido realizado com sucesso!');
                        this.props.history.push('/main/pedidos/' + orcamento.idtPedido);
                    }else{
                        toast.error('Erro ao realizar pedido.');
                    }
                    
                    finishLoading();
                }
            );
        }
    }

    atualizarValoresProdutos = () => {
        const { orcamento } = this.state;
        this.setState({ isLoading: true });

        HttpService.call(
            'cadastro/orcamentoVenda',
            'atualizarValoresOrcamento',
            [
                orcamento.idtPedido,
                orcamento.clienteId,
                LocalStorageManager.getOrigem().idt
            ],
            (retorno) => {
                if(isDefined(retorno) && retorno.result){
                    toast.success('Orçamento atualizado com sucesso!');
                    this.buscarDetalhesOrcamento(orcamento.idtPedido);
                }else{
                    toast.error('Erro ao atualizar valores do orçamento.');
                    this.setState({ isLoading: false });
                }
            }
        );
    }

	atualizarEndereco = (endereco) => {
		if (!isDefined(endereco)){
			toast.error(<div><p>Erro ao buscar CEP!</p> O serviço pode estar temporariamente indisponível.</div>);
		} else if (endereco.erro){
			toast.warn(endereco.mensagem);
		} else {
            this.buscarCidades(endereco.estado);

			this.setState({ orcamento: {
					...this.state.orcamento,
					...endereco
				} 
			});
		}
		
		this.setState({ isLoadingCep: false });
	}

    handleChangeOrcamento = (e, { name, value }) => {
		let orcamento;
		
		switch(name){
            case 'cep':
                value = mascaraCep(value);

                if(value.length === 9){
                    this.setState({ isLoadingCep: true });
                    
                    HttpService.call(
                        'cadastro/orcamentoVenda',
                        'buscarEnderecoCep',
                        [
                            value,
                            LocalStorageManager.getOrigem().idt
                        ],
                        this.atualizarEndereco
                    )
                }

                orcamento = {
                    [name]: value
                }
                break;
            case 'tipoFrete':
                let valorFrete = this.state.orcamento.valorFrete;

                // Se o frete for do tipo "Frete à pagar", zera o Valor do Frete e bloqueia o campo
                if(value === 'AP'){
                    valorFrete = '';
                }

                orcamento = {
                    [name]: value,
                    valorFrete
                }
                break;
			case 'valorFrete':
                orcamento = { 
                    [name]: decimalFormat(value, 2)
                }
				break;
            case 'estado':
                this.buscarCidades(value);

                orcamento = {
                    [name]: value,
                    codigoCidade: '',
                    cidade: ''
                }
                break;
            case 'codigoCidade':
                orcamento = {
                    [name]: value,
                    cidade: _.find(this.state.cidades, c => c.value === value).text
                }
                break;
			case 'produtos':
                orcamento = { 
                    [name]: value,
                    valorTotal: _.sum(_.map(value, p => parseDecimal(p.quantidade, 3) * parseDecimal(p.valorUnitario, 2))).toFixed(2),
                    quantidadeItens: value.length
                }
				break;
            case 'formaPagamentoId':
                orcamento = {
                    [name]: value,
                    nomeFormaPagamento: _.find(this.state.formasPagamento, f => f.value === value).text
                }
                break;
			default:
				orcamento = { 
					[name]: value
				}
		}

		this.setState({ orcamento: {
			...this.state.orcamento, 
			...orcamento,
            editado: true
		} });
    }

    imprimirPedido = () => {
        this.setState({ isPrinting: true });
        
        HttpService.call(
			'consulta/documento',
			'imprimirPedido',
			[
                this.state.orcamento.idtPedido,
                LocalStorageManager.getOrigem().idt,
                'PORTAL PEDIDOS'
            ],
			(documento) => {
                this.setState({ isPrinting: false })
                
				if(isDefined(documento)){
                    download(b64toBlob(documento.data, documento.mimeType), documento.filename, documento.mimeType);
				}
			}
        )
    }
    
    fecharModal = () => {
        const idtOrcamento = parseInt(this.props.match.params.idtOrcamento, 10);
        const urlOrcamentos = this.props.match.url.replace('/' + idtOrcamento, '');
        
        this.props.history.push(urlOrcamentos);
    }

    render(){
        const { orcamento, formasPagamento, cidades, confirmarSalvar, confirmarFecharPedido, isEditing, isPrinting, isLoading, isLoadingCep } = this.state;
        const isCliente = LocalStorageManager.getLoggedUser().isCliente;
        // É valido se a data do orçamento for a mesma do dia atual
        const orcamentoValido = isDefined(orcamento.dataPedido) && orcamento.dataPedido.isSame(new Moment(), 'day');
        const tipoFrete = _.find(tipoFreteOptions, t => t.value === orcamento.tipoFrete);

        return (
            <div>
                <Modal open size='large'>
                    <Modal.Header>
                    { 
                        isDefined(orcamento.idtPedido) ? (
                            <span>
                                Orçamento <a>#{ orcamento.idtPedido }</a>
                            </span>
                        ) : ( 
                            'Carregando orçamento...' 
                        )
                    }
                    </Modal.Header>
                    <Modal.Content scrolling>
                    {
                        isLoading && !isDefined(orcamento.idtPedido) ? (
                            <Dimmer active inverted>
                                <Loader>Carregando</Loader>
                            </Dimmer>
                        ) : (
                            <Modal.Description>
                                <Dimmer active={isLoading} inverted>
                                    <Loader>Carregando</Loader>
                                </Dimmer>
                                <If test={!orcamentoValido}>
                                    <Message warning icon style={{ marginTop: 0 }}>
                                        <Icon name='warning sign' />
                                        <Message.Content>
                                            <Message.Header>Este orçamento não é mais válido!</Message.Header>
                                            <p>
                                                <ButtonLink onClick={this.atualizarValoresProdutos} text='Clique aqui' /> para atualizar os valores dos produtos.
                                            </p>
                                        </Message.Content>
                                    </Message>
                                </If>
                                <Form size='small'>
                                    <Form.Group>
                                        <Form.Field width={4}>
                                            <label>Data</label>
                                            <Label size='large' className='fluid'>{isDefined(orcamento.dataPedido) ? orcamento.dataPedido.format('DD/MM/YYYY') : ''}</Label>
                                        </Form.Field>
                                        <Form.Field width={4}>
                                            <label>Controle</label>
                                            <Label size='large' className='fluid'>{orcamento.controle}</Label>
                                        </Form.Field>
                                        <If test={isCliente}>
                                            <Form.Field width={8}>
                                                <label>Vendedor</label>
                                                <Label size='large' className='fluid'>{orcamento.nomeVendedor}</Label>
                                            </Form.Field>
                                        </If>
                                        <If test={!isCliente}>
                                            <Form.Field width={8}>
                                                <label>Supervisor</label>
                                                <Label size='large' className='fluid'>{orcamento.nomeSupervisor}</Label>
                                            </Form.Field>
                                        </If>
                                    </Form.Group>
                                    <If test={!isCliente}>
                                        <Form.Field>
                                            <label>Cliente</label>
                                            <Label size='large' className='fluid'>{orcamento.nomeCliente}</Label>
                                        </Form.Field>
                                    </If>
                                    <Form.Group widths='equal'>
                                        <Form.Field width={4}>
                                            <label>Quantidade de produtos</label>
                                            <Label size='large' className='fluid'>{orcamento.quantidadeItens}</Label>
                                        </Form.Field>
                                        <Form.Field width={4}>
                                            <label>Valor Total (R$)</label>
                                            <Label size='large' className='fluid text-align-right'>{decimalFormat(orcamento.valorTotal, 2)}</Label>
                                        </Form.Field>
                                        <Form.Field width={8}>
                                            <label>Forma de pagamento</label>
                                            {
                                                isEditing ? (
                                                    <Dropdown fluid search selection name='formaPagamentoId'
                                                        selectOnBlur={false}
                                                        noResultsMessage='Nenhum resultado encontrado' 
                                                        value={orcamento.formaPagamentoId}
                                                        options={formasPagamento}
                                                        loading={formasPagamento === undefined}
                                                        onChange={this.handleChangeOrcamento}/>
                                                ) : (
                                                    <Label size='large' className='fluid'>{orcamento.nomeFormaPagamento}</Label>
                                                )
                                            }
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Field control={TextArea} readOnly={!isEditing} label='Observações' name='observacoes' value={orcamento.observacoes} onChange={this.handleChangeOrcamento} />
                                </Form>
                                <Divider horizontal>Frete</Divider>
                                <Form size='small'>
                                    <Form.Group widths='equal'>
                                        <Form.Field>
                                            <label>Tipo de frete</label>
                                            {
                                                isEditing ? (
                                                    <Dropdown label='Tipo de frete' name='tipoFrete'
                                                            fluid selection 
                                                            disabled={!isEditing}
                                                            value={orcamento.tipoFrete}
                                                            options={tipoFreteOptions} 
                                                            onChange={this.handleChangeOrcamento}/>
                                                ) : (
                                                    <Label size='large' className='fluid'>{isDefined(tipoFrete) ? tipoFrete.text : ''}</Label>
                                                )
                                            }
                                        </Form.Field>
                                        <Form.Field>
                                            <label>CEP</label>
                                            <EditableLabel edit={isEditing} loading={isLoadingCep} name='cep' value={orcamento.cep} onChange={this.handleChangeOrcamento} />
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Valor Frete (R$)</label>
                                            <EditableLabel edit={isEditing && !isCliente} disabled={orcamento.tipoFrete === 'AP'} name='valorFrete' value={decimalFormat(orcamento.valorFrete, 2)} onChange={this.handleChangeOrcamento} />
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Data de entrega</label>
                                            <Label size='large' className='fluid'>{isDefined(orcamento.dataEntrega) ? orcamento.dataEntrega.format('DD/MM/YYYY') : ''}</Label>
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Field width={8}>
                                            <label>Endereço</label>
                                            <EditableLabel edit={isEditing} name='endereco' value={orcamento.endereco} onChange={this.handleChangeOrcamento} />
                                        </Form.Field>
                                        <Form.Field width={2}>
                                            <label>Número</label>
                                            <EditableLabel edit={isEditing} name='numeroEndereco' value={orcamento.numeroEndereco} onChange={this.handleChangeOrcamento} />
                                        </Form.Field>
                                        <Form.Field width={6}>
                                            <label>Complemento</label>
                                            <EditableLabel edit={isEditing} name='complemento' value={orcamento.complemento} onChange={this.handleChangeOrcamento} />
                                        </Form.Field>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Field>
                                            <label>Bairro</label>
                                            <EditableLabel edit={isEditing} name='bairro' value={orcamento.bairro} onChange={this.handleChangeOrcamento} />
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Estado</label>
                                            {
                                                isEditing ? (
                                                    <Dropdown fluid selection search upward name='estado'
                                                              noResultsMessage='Nenhum resultado encontrado'
                                                              placeholder='Selecione um estado'
                                                              selectOnNavigation={false}
                                                              selectOnBlur={false}
                                                              value={orcamento.estado}
                                                              options={estadoOptions}
                                                              onChange={this.handleChangeOrcamento}/>
                                                ) : (
                                                    <Label size='large' className='fluid'>{orcamento.estado}</Label>
                                                )
                                            }
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Cidade</label>
                                            {
                                                isEditing ? (
                                                    <Dropdown fluid selection search upward name='codigoCidade'
                                                              noResultsMessage='Nenhum resultado encontrado'
                                                              placeholder='Selecione uma cidade'
                                                              loading={!isEmpty(orcamento.estado) && !isDefined(cidades)}
                                                              disabled={isEmpty(orcamento.estado) && !isDefined(cidades)}
                                                              selectOnNavigation={false}
                                                              selectOnBlur={false}
                                                              value={orcamento.codigoCidade}
                                                              options={cidades}
                                                              onChange={this.handleChangeOrcamento}/>
                                                ) : (
                                                    <Label size='large' className='fluid'>{orcamento.cidade}</Label>
                                                )
                                            }
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                                <Divider horizontal>Produtos</Divider>
                                <ModalProdutos produtos={orcamento.produtos} cliente={orcamento.clienteId} disabled={!isEditing} onChange={(produtos) => this.handleChangeOrcamento(null, { name: 'produtos', value: produtos })} />
                                <Table compact striped selectable singleLine size='small'>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='left'>Descrição</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='center'>Quantidade</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='center'>Valor unitário (R$)</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='center'>Desconto (%)</Table.HeaderCell>
                                            <Table.HeaderCell textAlign='center'>Valor total (R$)</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                    {   
                                        isDefined(orcamento.produtos) && orcamento.produtos.length > 0 ? (
                                            orcamento.produtos.map((item, index) => {
                                                return <Table.Row key={index}>
                                                            <Table.Cell textAlign='center'>{item.codigo}</Table.Cell>
                                                            <Table.Cell textAlign='left'>{item.descricao}</Table.Cell>
                                                            <Table.Cell textAlign='right'>{decimalFormat(item.quantidade, 3)}</Table.Cell>
                                                            <Table.Cell textAlign='right'>{decimalFormat(item.valorUnitario, 2)}</Table.Cell>
                                                            <Table.Cell textAlign='right'>{decimalFormat(item.percentualDesconto, 2)}</Table.Cell>
                                                            <Table.Cell textAlign='right'>{decimalFormat(item.valorTotal, 2)}</Table.Cell>
                                                        </Table.Row>
                                            })
                                        ) : (
                                            <Table.Row>
                                                <Table.Cell colSpan='5'>Nenhum produto adicionado.</Table.Cell>
                                            </Table.Row>
                                        )
                                    }
                                    </Table.Body>
                                </Table>
                            </Modal.Description>
                        )
                    }
                    </Modal.Content>
                    <Modal.Actions>
                        <If test={isEditing}>
                            <Button floated='left' icon='remove' content='Cancelar' onClick={() => this.buscarDetalhesOrcamento(orcamento.idtPedido)} />
                            <Button positive icon='download' content='Salvar' onClick={() => this.salvarOrcamento()}/>
                        </If>
                        <If test={!isEditing}>
                            <Button negative floated='left' content='Fechar' icon='window close' onClick={this.fecharModal} />
                            <Button secondary={orcamentoValido} disabled={!orcamentoValido} loading={isPrinting} onClick={this.imprimirPedido}>
                                <Icon name='print'/>
                                Imprimir
                            </Button>
                            <Button primary={orcamentoValido} disabled={!orcamentoValido} onClick={() => this.setState({ isEditing: true })}>
                                <Icon name='write'/>
                                Alterar orçamento
                            </Button>
                            <Button positive={orcamentoValido} disabled={!orcamentoValido || orcamento.formaPagamentoId === ''} onClick={this.fecharPedido}>
                                <Icon name='checkmark'/>
                                Fechar pedido
                            </Button>
                        </If>
                    </Modal.Actions>
                </Modal>

                <ConfirmSave open={confirmarSalvar}
                            modalSize='tiny' 
                            iconSize='huge'
                            iconName='money'
                            iconColor='green'
                            cancelButton='Cancelar'
                            confirmButton='Confirmar e salvar'
                            header='Confirmar Forma de Pagamento'
                            onCancel={() => this.setState({ confirmarSalvar: false })}
                            onConfirm={this.salvarOrcamento}
                            content={
                                <div>
                                    <h3>Você confirma a forma de pagamento abaixo para o pedido?</h3>
                                    <Form>
                                        <Form.Group widths='equal'>
                                            <Form.Field>
                                                <label>Forma de pagamento</label>
                                                <Label size='large' className='fluid'>
                                                { isDefined(_.find(formasPagamento, (item) => item.value === orcamento.formaPagamentoId)) ? _.find(formasPagamento, (item) => item.value === orcamento.formaPagamentoId).text : null }
                                                </Label>
                                            </Form.Field>
                                            <Form.Field>
                                                <label>Valor (R$)</label>
                                                <Label size='large' className='fluid text-align-right'>
                                                    {decimalFormat(orcamento.valorTotal, 2)}
                                                </Label>
                                            </Form.Field>
                                        </Form.Group>
                                        <Form.Field required>
                                            <label>Senha de confirmação</label>
                                            <Input fluid autoFocus type='password' placeholder='Digite a sua senha' value={this.state.senhaConfirmacao} onChange={(e, { value }) => this.setState({ senhaConfirmacao: value })}/>
                                        </Form.Field>
                                    </Form>
                                </div>
                            }/>


                <ConfirmSave open={confirmarFecharPedido}
                            modalSize='tiny' 
                            iconSize='huge'
                            iconColor='green'
                            iconName='checkmark'
                            cancelButton='Cancelar'
                            confirmButton='Fechar pedido'
                            header='Confirmar Fechamento Pedido'
                            onCancel={() => this.setState({ confirmarFecharPedido: false })}
                            onConfirm={this.fecharPedido}
                            content={
                                <div>
                                    <h3>Você confirma o fechamento deste pedido?</h3>
                                    <Form>
                                        <Form.Field>
                                            <label>Quantidade de produtos</label>
                                            <Label size='large' className='fluid'>{orcamento.quantidadeItens}</Label>
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Forma de pagamento</label>
                                            <Label size='large' className='fluid'>
                                                {isDefined(_.find(formasPagamento, (item) => item.value === orcamento.formaPagamentoId)) ? _.find(formasPagamento, (item) => item.value === orcamento.formaPagamentoId).text : null}
                                            </Label>
                                        </Form.Field>
                                        <Form.Field>
                                            <label>Valor (R$)</label>
                                            <Label size='large' className='fluid'>
                                                {decimalFormat(orcamento.valorTotal, 2)}
                                            </Label>
                                        </Form.Field>
                                    </Form>
                                </div>
                            }/>
            </div>
        )
    }
}

export default DetalheOrcamento;


// WEBPACK FOOTER //
// ./src/views/OrcamentoVenda/DetalheOrcamento.js